;(function($) {

    'use strict';

    $(document).ready(function() {
        setTimeout(function() {
            $controller.init();
        }, 100);
    });

    var $controller = {

        selector: '#php_serialize_form',
        el: null,
        input: null,

        PROVIDER: null,

        init: function() {

            this.el = $(this.selector);
            if(this.el.length > 0) {
                this.handle();
            }

        },

        handle: function() {
            this.prepare();
            this.listen();
        },

        prepare: function() {
            this.PROVIDER = require('php-serialize');
            this.input = $('textarea', this.el);
        },

        listen: function() {

            $('.btn-unserialize', this.el).click(function($evt) {
                $evt.preventDefault();
                var $value = $controller.input.val();
                $controller.input.val($controller.stringify($controller.unserialize($value)));
            });

            $('.btn-serialize', this.el).click(function($evt) {
                $evt.preventDefault();
                var $value = $controller.input.val();
                $controller.input.val($controller.serialize($controller.parse($value)));
            });

        },

        log: function() {
            if(console && console.log) {
                console.log.apply(console, arguments);
            }
        },

        stringify: function($value) {
            return JSON.stringify($value, null, 2); // NOTE: pretty print
        },

        parse: function($value) {
            // TODO: php to php-serialized
            // NOTE: right now, just JSON to serialized
            try {
                $value = this.stringify($value);
                $controller.log('after stringify', $value, typeof $value);
                $value = JSON.parse($value);
                $controller.log('after JSON.parse', $value, typeof $value);
                return $value;
            } catch($e) {
                $controller.log('PARSE ERROR', $value, $e);
            }
            return {};
        },

        unserialize: function($value) {
            try {
                return this.PROVIDER.unserialize($value, {stdClass: Object});
            } catch($e) { 
                $controller.log('UNSERIALIZE ERROR', $value, $e);
            }
            return '';
        },

        serialize: function($value) {
            try {
                return this.PROVIDER.serialize($value);
            } catch($e) { 
                $controller.log('SERIALIZE ERROR', $value, $e);
            }
            return '';
        }

    };


})(jQuery);


// WEBPACK FOOTER //
// ./build/vendor/tbo/js/form/php-serialize.js